import { ref } from 'vue'

const toasts = ref([])

let toastId = 0

export function useToast() {
  const addToast = (toast) => {
    const id = `toast-${++toastId}`
    const newToast = {
      id,
      duration: 5000,
      persistent: false,
      ...toast
    }
    
    toasts.value.push(newToast)
    
    if (!newToast.persistent && newToast.duration && newToast.duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, newToast.duration)
    }
    
    return id
  }

  const removeToast = (id) => {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  const clearAllToasts = () => {
    toasts.value.splice(0)
  }

  // Convenience methods
  const success = (title, message, options = {}) => {
    return addToast({ type: 'success', title, message, ...options })
  }

  const error = (title, message, options = {}) => {
    return addToast({ type: 'error', title, message, duration: 7000, ...options })
  }

  const warning = (title, message, options = {}) => {
    return addToast({ type: 'warning', title, message, ...options })
  }

  const info = (title, message, options = {}) => {
    return addToast({ type: 'info', title, message, ...options })
  }

  return {
    toasts: toasts,
    addToast,
    removeToast,
    clearAllToasts,
    success,
    error,
    warning,
    info
  }
}
